import { Box, Grid, Divider, List } from "@mui/material";
import { H3, H4 } from "../components/Typography";
import CustomButton from "../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import Success from "../assets/Lottifies/sucessPayment.json";
import Failed from "../assets/Lottifies/failed.json";
import Pending from "../assets/Lottifies/pending.json";
import { API_BASE_URL } from "../Api/EndPoints";

type GSTransactionDetailProps = {
  status: string;
  item: any;
  type: string;
  data: any;
  screenName?: any;
};

const MFTransactionDetail: React.FC<GSTransactionDetailProps> = (props) => {
  let navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          background: "#F6F6F6",
          pl: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pr: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pb: 2,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Player
          autoplay
          loop
          src={
            props?.item?.status === "PAYMENT_CONFIRMED" ||
            props?.item?.status === "SUCCESSFUL"
              ? Success
              : props.item?.status === "FAILED"
              ? Failed
              : props?.item?.status === "INITIATED"
              ? Failed
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Redeemed"
              ? Success
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Sell"
              ? Success
              : Pending
          }
          style={{ height: "150px", width: "150px" }}
        />
        <H3
          color={
            props?.item?.status === "PAYMENT_CONFIRMED" ||
            props?.item?.status === "SUCCESSFUL"
              ? "#22bb33"
              : props?.item?.status === "FAILED"
              ? "#FF0000"
              : props?.item?.status === "INITIATED"
              ? "#FF0000"
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Redeemed"
              ? "#22bb33"
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Sell"
              ? "#22bb33"
              : "#FF9300"
          }
          sx={{
            fontFamily: "'Poppins', sans-serif",
            width: "40%",
            pt: 2,
            textAlign: "center",
          }}
        >
          {(props?.item?.orderId?.includes("SELF") &&
            props?.item?.status === "PAYMENT_CONFIRMED") ||
          props?.item?.status === "SUCCESSFUL"
            ? "Transaction Successful"
            : props?.item?.orderId?.includes("JOY") &&
              props?.item?.status === "PAYMENT_CONFIRMED"
            ? "Transaction Successful"
            : props?.item?.status === "PAYMENT_CONFIRMED"
            ? "Transaction Successful"
            : props?.item?.status === "FAILED"
            ? "Transaction Failed"
            : props?.item?.status === "INITIATED"
            ? "Transaction Failed"
            : props?.item?.status === "Executed" &&
              props?.item?.txnType === "Redeemed"
            ? "Transaction Successful"
            : props?.item?.status === "Executed" &&
              props?.item?.txnType === "Sell"
            ? "Transaction Successful"
            : props?.item?.type === "REDEEM_ALL"
            ? "Redeemption in process"
            : "Transaction In Progress"}
        </H3>
        <Box
          sx={{
            border: "0.5px solid rgba(255, 239, 236, 0.5)",
            borderRadius: "12px",
            background: "#ffff",
            width: {
              md: "40%",
              xs: "90%",
            },
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            mt: 1.5,
            mb: 1,
            p: 2,
          }}
        >
          <Box
            component="img"
            src={
              props?.item?.fund_scheme?.logo
                ? API_BASE_URL + props?.item?.fund_scheme?.logo
                : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
            }
            sx={sxStyleImage}
          />

          <H4
            fontSize={14}
            fontWeight={"700"}
            sx={{
              fontFamily: "'Poppins', sans-serif",
              pt: 2,
              pb: 0,
            }}
          >
            {props?.item?.fund_scheme.name}
          </H4>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {props?.data?.map((item: any, key: any) => (
              <>
                <Grid
                  justifyContent="space-between"
                  sx={{ display: "flex", p: 1 }}
                >
                  <H4 sx={{ fontFamily: "'Poppins', sans-serif" }}>
                    {item?.title}
                  </H4>
                  <H4>{item?.subTitle}</H4>
                </Grid>
                <Divider />
              </>
            ))}
          </List>
        </Box>
        <CustomButton
          title=" Back to Home"
          onPress={() => navigate("/dashboard")}
          width={"40%"}
          sWidth={"90%"}
        />
      </Box>
    </>
  );
};

export default MFTransactionDetail;
const sxStyleImage = {
  height: 80,
  width: 80,
  mt: 2,
  borderRadius: 2,
};
